<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <v-card>
          <v-toolbar color="primary">
            <v-icon color="white">mdi-eye</v-icon>
            <v-toolbar-title class="white--text">{{ $t('admin.modules.permissions.title') }}</v-toolbar-title>
          </v-toolbar>

          <v-layout>
            <v-flex>
              <v-card-text>
                <v-treeview
                  v-model="tree"
                  :load-children="fetch"
                  :items="items"
                  activatable
                  :active.sync="activeItems"
                  active-class="grey lighten-4 indigo--text"
                  selected-color="indigo"
                  open-on-click
                  selectable
                  expand-icon="mdi-chevron-down"
                  on-icon="mdi-eye"
                  off-icon="mdi-eye-off"
                  indeterminate-icon="mdi-eye-circle"
                />
              </v-card-text>
            </v-flex>
          </v-layout>

          <v-divider/>

          <v-card-actions>
            <v-btn
              flat
              @click="tree = []" round>Reset</v-btn>

            <v-spacer/>

            <v-btn
              class="white--text"
              color="secondary"
              depressed round>
              {{ $t('save-button-label') }}
              <v-icon right>mdi-content-save</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import i18n from '../i18n/index'
import PermissionsService from '../services/PermissionsService'

export default {
  data: () => ({
    breweries: [],
    isLoading: false,
    tree: [],
    types: [],
    selectedRole: 1,
    options: [],
    activeItems: [1, 2]
  }),

  computed: {
    items () {
      let children = this.lodash.map(this.options, this.translate)
      this.activeItems = [1, 2]
      return [
        {
          id: 0,
          name: i18n.t('admin.modules.permissions.all-permissions-label'),
          children
        }
      ]
    }
    /* selections() {
      const selections = [];

      for (const leaf of this.tree) {
        const brewery = this.options.find(brewery => brewery.id === leaf);

        if (!brewery) continue;

        selections.push(brewery);
      }

      return selections;
    } */
  },

  methods: {
    fetch () {
      if (this.options.length) return

      return PermissionsService.getPermissions(this.selectedRole).then(
        result => {
          this.options = result.data.options
        }
      )
    },

    translate (option) {
      let data = JSON.parse(option.data)
      let item = {
        id: option.id,
        name: data.name
      }

      if (option.children) { item.children = this.lodash.map(option.children, this.translate) }

      return item
    }
  }
}
</script>
